


























































































import CategoryTreeNode, {
  CategoryTreeNodeType
} from '@/models/CategoryTreeNode'
import NewYorkLessonPostTree from './NewYorkLessonPostTree.vue'
import Vue from 'vue'
export default Vue.extend({
  components: {
    NewYorkLessonPostTree
  },
  props: {
    categoryTree: {
      type: Array
    },
    activePost: {
      type: Object
    },
    previousCategory: Object,
    nextCategory: Object,
    category: Object,
    completedPosts: {
      type: Set,
      default: new Set()
    },
    categoryNavIcon: String,
    highlightBackground: String,
    highlightColor: String
  },
  computed: {
    productId(): string {
      return this.$route.params.id
    },
    categoryId(): string {
      return this.$route.params.category_id
    },
    templateId(): string {
      return this.$route.query.template_id
    },
    currentCategoryTree(): object {
      let id = this.categoryId
      if (this.category?.parentCategory) {
        id = this.category?.parentCategory
      }
      return (
        this.categoryTree.find((node: CategoryTreeNode) => node.id === id) ||
        null
      )
    },
    postIndexes(): object {
      let index = 1
      return this.currentCategoryTree?.childs?.reduce(
        (agg, node: CategoryTreeNode) => {
          if (node.type === CategoryTreeNodeType.Post) {
            agg[node.id] = index++
          } else {
            for (let i = 0; i < node.childs.length; i++) {
              agg[node.childs[i].id] = index++
            }
          }
          return agg
        },
        {}
      )
    }
  }
})
